import { getFont } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../../utils/style';
import { getCenter } from '../../utils/sizes';
import {
  HEIGHT,
  ICON_HEIGHT,
  LABEL_FONT,
  BORDER_WIDTH,
  BORDER_RADIUS,
  FOCUSED_BACKGROUND_COLOR,
  FOCUSED_CONTENT_COLOR,
  FOCUSED_OUTER_BORDER_COLOR,
  FOCUSED_INNER_BORDER_COLOR,
  UNFOCUSED_BACKGROUND_COLOR,
  UNFOCUSED_CONTENT_COLOR,
  UNFOCUSED_OUTER_BORDER_COLOR,
  UNFOCUSED_INNER_BORDER_COLOR,
  LOADING_BAR_COLOR,
  LOADING_INNER_BORDER_COLOR,
  LOADING_BACKGROUND_COLOR,
  LOADING_CONTENT_COLOR,
  LOADING_OUTER_BORDER_COLOR,
} from './callToAction.constants';

export const defaultContext = makeDefaultStylingContext();

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const h = HEIGHT[screenSize];
  const font = getFont(LABEL_FONT, screenSize);
  const borderWidth = BORDER_WIDTH[screenSize];

  return {
    h,
    Background: {
      x: -borderWidth,
      y: -borderWidth,
      h: h + borderWidth * 2,
      w: v => v + borderWidth * 2,
      rect: true,
      shader: {
        borderWidth,
        fillColor: UNFOCUSED_BACKGROUND_COLOR[colorMode],
        innerBorderColor: UNFOCUSED_INNER_BORDER_COLOR[colorMode],
        outerBorderColor: UNFOCUSED_OUTER_BORDER_COLOR[colorMode],
        radius: BORDER_RADIUS[screenSize],
        progressColor: LOADING_BAR_COLOR[colorMode],
        scale: 1,
      },
    },
    Icon: {
      color: UNFOCUSED_CONTENT_COLOR[colorMode],
      y: getCenter(h, ICON_HEIGHT[screenSize]),
    },
    Label: {
      color: UNFOCUSED_CONTENT_COLOR[colorMode],
      y: getCenter(h, font.lineHeight),
      text: {
        ...font,
        verticalAlign: 'middle',
      },
    },
  };
};

export const getProgressStyle = ({ colorMode }) => ({
  Background: {
    shader: {
      fillColor: LOADING_BACKGROUND_COLOR[colorMode],
      innerBorderColor: LOADING_INNER_BORDER_COLOR[colorMode],
      outerBorderColor: LOADING_OUTER_BORDER_COLOR[colorMode],
      scale: 1,
    },
    scale: 1,
  },
  Icon: {
    color: LOADING_CONTENT_COLOR[colorMode],
  },
  Label: {
    color: LOADING_CONTENT_COLOR[colorMode],
  },
});

export const getUnFocusedStyle = ({ colorMode }) => ({
  Background: {
    smooth: {
      'shader.fillColor': UNFOCUSED_BACKGROUND_COLOR[colorMode],
      'shader.innerBorderColor': UNFOCUSED_INNER_BORDER_COLOR[colorMode],
      'shader.outerBorderColor': UNFOCUSED_OUTER_BORDER_COLOR[colorMode],
      'scale.scale': 1,
      scale: 1,
    },
  },
  Icon: {
    color: UNFOCUSED_CONTENT_COLOR[colorMode],
  },
  Label: {
    color: UNFOCUSED_CONTENT_COLOR[colorMode],
  },
});

export const getFocusedStyle = ({ colorMode }) => ({
  Background: {
    smooth: {
      'shader.fillColor': FOCUSED_BACKGROUND_COLOR[colorMode],
      'shader.innerBorderColor': FOCUSED_INNER_BORDER_COLOR[colorMode],
      'shader.outerBorderColor': FOCUSED_OUTER_BORDER_COLOR[colorMode],
      'scale.scale': 1.05,
      scale: 1.05,
    },
  },
  Icon: {
    color: FOCUSED_CONTENT_COLOR[colorMode],
  },
  Label: {
    color: FOCUSED_CONTENT_COLOR[colorMode],
  },
});
